interface ProductInfo {
  name: string;
  size: string | null;
  color: string | null;
}

export const parseProductName = (productName: string): ProductInfo => {
  if (!productName) {
    return { name: "", size: null, color: null };
  }

  let cleanName = productName;
  let size: string | null = null;
  let color: string | null = null;

  // Regex do wyciągnięcia rozmiaru - uwzględnia otwierający nawias
  const sizeMatch = productName.match(/\(Rozmiar:\s*([^)]+)\)/i);
  if (sizeMatch) {
    size = sizeMatch[1]?.trim() || null;
  }

  // Regex do wyciągnięcia koloru - uwzględnia strukturę z myślnikiem
  const colorMatch = productName.match(/-\s*Kolor:\s*([^)]+)\)/i);
  if (colorMatch) {
    color = colorMatch[1]?.trim() || null;
  }

  // Usuń cały fragment od pierwszego nawiasu otwierającego
  cleanName = cleanName.replace(/\s*\(.*?\)$/, "").trim();

  return {
    name: cleanName,
    size,
    color,
  };
};
